import { mustBeFilled, mustBeLessThan, mustBeMoreThan } from '../../libs/validators';

export const inputTextareaDescriptionConfig = {
  label: 'Description du problème rencontré',
  maxChars: 1500,
  name: 'textareaDescription',
  rows: 11,
  title: 'Laisser un commentaire',
  validators: {
    format: [mustBeMoreThan(3), mustBeLessThan(1500)],
    submit: mustBeFilled('Veuillez saisir une description au problème rencontré'),
  },
};
